interface SubmissionNoticeProps {
  message: string;
}

/**
 * Displays a submission notice banner at the top of forms.
 * Used for informing users about the workflow and next steps.
 */
export function SubmissionNotice({ message }: SubmissionNoticeProps) {
  return (
    <div
      role="region"
      aria-label="Submission notice"
      style={{
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderLeft: '4px solid #0078d4',
        borderRadius: '4px',
        padding: '16px',
        marginBottom: '24px',
        display: 'flex',
        gap: '12px',
        alignItems: 'flex-start',
      }}
    >
      <div style={{ color: '#0078d4', fontSize: '1.1rem', flexShrink: 0 }}>ℹ️</div>
      <div style={{ color: '#333', fontSize: '0.9rem', lineHeight: '1.5', flex: 1 }}>
        <strong style={{ fontWeight: 600 }}>Submission Notice:</strong> {message}
      </div>
    </div>
  );
}
